







import { Prop, Component, Vue } from 'vue-property-decorator';
import {
  fetchNotifications_notifications,
  fetchNotifications_notifications_subject,
  NotificationStatusEnum
} from '@/types/graphql/schemaTypes';

@Component({})
export default class Notification extends Vue {
  @Prop() public notification!: fetchNotifications_notifications;

  private isUnread(): boolean {
    return this.notification.status === NotificationStatusEnum.unread;
  }

  private close(): void {
    this.$store.dispatch('User/closeNotifications');
  }

  private goToItem(): void {
    const subject = this.notification.subject as fetchNotifications_notifications_subject;

    switch (this.notification.notificationType) {
      case 'vessel_delayed':
        this.$router.push({
          name: 'shipmentActivities',
          params: { id: subject.shipmentId }
        });
        break;
      case 'new_inquiry':
        this.close();
        this.$router.push({
          name: 'inquiryQuote',
          params: { id: subject.shipmentId || '' }
        });
        break;

      case 'quote_accepted':
        this.close();
        this.$router.push({
          name: 'shipmentActivities',
          params: { id: subject.shipmentId || '' }
        });
        break;

      case 'message_added':
      case 'private_message_added':
      case 'message_file_added':
        this.close();
        if (subject.shipmentStatus === 'shipment') {
          this.$router.push({
            name: 'shipmentChannels',
            params: { id: subject.shipmentId || '' }
          });
        } else {
          this.$router.push({
            name: 'inquiryChannels',
            params: { id: subject.shipmentId || '' }
          });
        }
        break;

      case 'file_added':
      case 'private_file_added':
        this.close();
        if (subject.shipmentStatus === 'shipment') {
          this.$router.push({
            name: 'shipmentAttachments',
            params: { id: subject.shipmentId || '' }
          });
        } else {
          this.$router.push({
            name: 'inquiryAttachments',
            params: { id: subject.shipmentId || '' }
          });
        }
        break;

      case 'bill_due':
        this.close();
        this.$router.push({
          name: 'bills'
        });
        break;

      case 'bill_paid':
        this.close();
        this.$router.push({
          name: 'bills'
        });
        break;
    }

    this.$emit('clicked');
  }
}
